export const REPORT_USER = 'REPORT_USER';
export const ADMINISTRATOR_USER = 'ADMINISTRATOR_USER';
export const ASSOCIATION_USER = 'ASSOCIATION_USER';
export const INSTITUTION_USER = 'INSTITUTION_USER';
export const SUPER_USER = 'SUPER_USER';
export const USERS_RESET = 'USERS_RESET';
export const RESET_SESSION = 'RESET_SESSION';

export const USER_TOKEN = 'USER_TOKEN';
export const USER_EMAIL = 'USER_EMAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_LOADING = 'USERS_LIST_LOADING';
export const RESET_USERS_LIST = 'RESET_USERS_LIST';
export const USER_IMPERSONATE = 'USER_IMPERSONATE';
export const USER_IMPERSONATE_END = 'USER_IMPERSONATE_END';
export const USER_IMPERSONATE_LOADING = 'USER_IMPERSONATE_LOADING';
export const USER_IMPERSONATE_LOADED = 'USER_IMPERSONATE_LOADED';
export const USER_IMPERSONATE_RESET = 'USER_IMPERSONATE_RESET';
export const PREVIEWS_CAS_DETAILS = 'PREVIEWS_CAS_DETAILS';
export const PREVIEW_USER = 'PREVIEW_USER';
export const PREVIEW_USER_RESET = 'PREVIEW_USER_RESET';
export const LOGGED_USER_DETAILS = 'LOGGED_USER_DETAILS';
export const USER_SET_INSTITUTION = 'USER_SET_INSTITUTION';
export const USER_SET_INSTITUTION_LOADING = 'USER_SET_INSTITUTION_LOADING';
export const USER_SET_ACTIVE_CAS = 'USER_SET_ACTIVE_CAS';

export const SEARCH_CAS = 'SEARCH_CAS';
export const SEARCH_ORGANIZATION = 'SEARCH_ORGANIZATION';
export const SEARCH_INSTITUTIONS = 'SEARCH_INSTITUTIONS';
export const SEARCH_USERROLES = 'SEARCH_USERROLES';
export const SEARCH_STATUSES = 'SEARCH_STATUSES';
export const SEARCH_FILTERS = 'SEARCH_FILTERS';
export const SEARCH_INTERNAL = 'SEARCH_INTERNAL';
export const SEARCH_FILTER_PANEL_TOGGLE = 'SEARCH_FILTER_PANEL_TOGGLE';
export const PILLSBUGS_ACTION = 'PILLSBUGS_ACTION';
export const PILLSBUGS_RESET = 'PILLSBUGS_RESET';
export const PILLSBUGS_SET_ITEM_STATE = 'PILLSBUGS_SET_ITEM_STATE';
export const TRUE_STRING = 'True';
export const FALSE_STRING = 'False';
export const SPECIALITY_CASLIST = 'SPECIALITY_CASLIST';
export const ORAGNIZATION_LIST_BY_CLIENT_ID = 'ORAGNIZATION_LIST_BY_CLIENT_ID';
export const SPECIALTY_USER = 'SPECIALTY_USER';
export const ASSOCIATION_SPECIALTY = 'ASSOCIATION_SPECIALTY';
export const SUPER_USER_SPECIALITY = 'SUPER_USER_SPECIALITY';
export const ASSOCIATION_SPECIALTY_LIST = 'ASSOCIATION_SPECIALTY_LIST';
